import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 40px);
  position: relative;
  background-color: ${(props) => props.theme.colors?.greys?.lighter};
`;
